import Link from '@/components/Link';
import { adBlockElName } from '@gik/ads/components/AdContainer';
import React from 'react';

export default function FallbackAd() {
  return (
    <Link href="/create">
      <div className={adBlockElName} />
    </Link>
  );
}
